module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bannerPlaceHolderForWhatsmore) ? _c('div', {
    staticClass: "fullWidth categorySection"
  }, [(_vm.renderData && _vm.renderData[0][3]) ? _c('p', {
    staticClass: "whatsmore-title"
  }, [_vm._v(_vm._s(_vm.renderData[0][3]))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "whatmore-base",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('div', {
    attrs: {
      "id": "whatmoreShopId",
      "data": _vm.contentKey
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreCollection",
      "data": _vm.contentCategory
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmorePrimaryColor",
      "data": "#d97777"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreSecondaryColor",
      "data": "#d97777"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreTitleFontSize",
      "data": "28"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreLandscapePadding",
      "data": "40"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreTopBottomPadding",
      "data": "20"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreVideoTileSize",
      "data": "80"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreVideoTileSizePortrait",
      "data": "80"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreTitleFont",
      "data": "sans-serif"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmorePrimaryFont",
      "data": "sans-serif"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreShowViews",
      "data": "show"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "whatmore-template-type",
    attrs: {
      "data": "template-b"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreIsInDesignMode",
      "data": "false"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreUITheme",
      "data": "round"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "whatmore-render-root"
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-733d8c3b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/whatsMore.vue
// module id = 2514
// module chunks = 73